/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import InlineResponse2009DataDocuments from './InlineResponse2009DataDocuments';

/**
 * The InlineResponse2009Data model module.
 * @module model/InlineResponse2009Data
 * @version 1.0.0
 */
class InlineResponse2009Data {
    /**
     * Constructs a new <code>InlineResponse2009Data</code>.
     * @alias module:model/InlineResponse2009Data
     */
    constructor() { 
        
        InlineResponse2009Data.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineResponse2009Data</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse2009Data} obj Optional instance to populate.
     * @return {module:model/InlineResponse2009Data} The populated <code>InlineResponse2009Data</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse2009Data();

            if (data.hasOwnProperty('student_academic_program_id')) {
                obj['student_academic_program_id'] = ApiClient.convertToType(data['student_academic_program_id'], 'Number');
            }
            if (data.hasOwnProperty('student_academic_program')) {
                obj['student_academic_program'] = ApiClient.convertToType(data['student_academic_program'], 'String');
            }
            if (data.hasOwnProperty('comments')) {
                obj['comments'] = ApiClient.convertToType(data['comments'], 'String');
            }
            if (data.hasOwnProperty('more_info')) {
                obj['more_info'] = ApiClient.convertToType(data['more_info'], 'String');
            }
            if (data.hasOwnProperty('status_id')) {
                obj['status_id'] = ApiClient.convertToType(data['status_id'], 'Number');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('selected_document_id')) {
                obj['selected_document_id'] = ApiClient.convertToType(data['selected_document_id'], 'Number');
            }
            if (data.hasOwnProperty('discount_id')) {
                obj['discount_id'] = ApiClient.convertToType(data['discount_id'], 'Number');
            }
            if (data.hasOwnProperty('discount_name')) {
                obj['discount_name'] = ApiClient.convertToType(data['discount_name'], 'String');
            }
            if (data.hasOwnProperty('documents')) {
                obj['documents'] = ApiClient.convertToType(data['documents'], [InlineResponse2009DataDocuments]);
            }
        }
        return obj;
    }


}

/**
 * Student Academic Program ID
 * @member {Number} student_academic_program_id
 */
InlineResponse2009Data.prototype['student_academic_program_id'] = undefined;

/**
 * Student Academic Program name
 * @member {String} student_academic_program
 */
InlineResponse2009Data.prototype['student_academic_program'] = undefined;

/**
 * Comments
 * @member {String} comments
 */
InlineResponse2009Data.prototype['comments'] = undefined;

/**
 * Additional information
 * @member {String} more_info
 */
InlineResponse2009Data.prototype['more_info'] = undefined;

/**
 * Status ID
 * @member {Number} status_id
 */
InlineResponse2009Data.prototype['status_id'] = undefined;

/**
 * Status name
 * @member {String} status
 */
InlineResponse2009Data.prototype['status'] = undefined;

/**
 * Selected document ID
 * @member {Number} selected_document_id
 */
InlineResponse2009Data.prototype['selected_document_id'] = undefined;

/**
 * Discount ID
 * @member {Number} discount_id
 */
InlineResponse2009Data.prototype['discount_id'] = undefined;

/**
 * Discount name
 * @member {String} discount_name
 */
InlineResponse2009Data.prototype['discount_name'] = undefined;

/**
 * List of documents
 * @member {Array.<module:model/InlineResponse2009DataDocuments>} documents
 */
InlineResponse2009Data.prototype['documents'] = undefined;






export default InlineResponse2009Data;

